import {Observable} from 'rxjs';
import {IMantBascula} from './../modelos/IMantBascula';
import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';

@Injectable({
  providedIn: 'root'
})
export class MantenimientoBasculaService {

  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<IMantBascula[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.mantBascula.obtenerTodo
    );
  }

  obtenerPorId(idBascula: number): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url +
      this.diccionarioModulo.url.mantBascula.obtenerPorId +
      idBascula
    );
  }

  obtenerCentros(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url +
      this.diccionarioModulo.url.mantBascula.centros
    );
  }

  crear(request: IMantBascula) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.mantBascula.crear,
      request
    );
  }

  editar(request: IMantBascula) {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.mantBascula.actualizar,
      request
    );
  }

  borrar(params: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url +
      this.diccionarioModulo.url.mantBascula.eliminar +
      params
    );
  }
}
